import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const EntdeckenSieMehr = (props) => {
  return (
    <section className="entdecken-sie-mehr">
      <h3>Entdecken Sie mehr von Bärkopf</h3>
      <div className="links-zu-anderen-reisen-container">
        {props.reisen.map((reise) => {
          var foo
          if (reise.typ === "Wanderreise") {
            foo = "wanderreisen"
          } else if (reise.typ === "Segel-Kreuzfahrt") {
            foo = "segelkreuzfahrten"
          } else if (reise.typ === "Golfreise") {
            foo = "golfreisen"
          }
          return (
            <Link
              key={reise.slug}
              className="reise"
              to={`/${foo}/${reise.land.toLowerCase()}/${reise.slug}`}
            >
              <GatsbyImage
                image={reise.heroImage.gatsbyImageData}
                alt={reise.destination}
              />
              <div className={`reise-text reise-text-${foo}`}>
                {reise.destination}
              </div>
            </Link>
          )
        })}
      </div>
    </section>
  )
}
export default EntdeckenSieMehr
